import { render, staticRenderFns } from "./MasterclassTile.vue?vue&type=template&id=a4dd0ebe&"
import script from "./MasterclassTile.vue?vue&type=script&lang=js&"
export * from "./MasterclassTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports